import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UserSessionListRequest, UserSessionListResponse, UserSessionModel } from 'core/models';
import { ApiListDataService } from './api.list-data.service';

@Injectable({
    providedIn: 'root',
})
export class ApiAdminUserSessionsService extends ApiListDataService<
    UserSessionModel,
    UserSessionModel
> {
    constructor(http: HttpClient) {
        super(http, '/Admin/');
    }

    public getUserSessions(model: UserSessionListRequest): Observable<UserSessionListResponse> {
        return this.get<UserSessionListResponse>('Sessions', { ...model });
    }
}
